import styled, { keyframes } from 'styled-components';

const pulse = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
`;

export const AdItem = styled.div`
  a {
    display: flex;
    flex-direction: column;
    height: 100%;
    text-decoration: none;
    color: #333;
    background: #fff;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

    &:hover {
      transform: translateY(-8px);
      box-shadow: 0 12px 30px rgba(0, 0, 0, 0.15);
    };

    .itemName {
      font-weight: 600;
      font-size: 15px;
      padding: 15px 15px 8px;
      color: #2c3e50;
      line-height: 1.4;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-transform: uppercase;
    };

    .itemPrice {
      padding: 0 15px 15px;
      font-size: 18px;
      font-weight: 700;
      color: #667eea;
    };
  };
`;

export const AdImageContainer = styled.div`
  height: 180px;
  width: 100%;
  position: relative;
  overflow: hidden;
  background-color: #f5f5f5;

  @media(max-width: 768px) {
    height: 160px;
  }

  @media(max-width: 480px) {
    height: 180px;
  }

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .placeholder {
    position: absolute;
    inset: 0;
    background: linear-gradient(90deg, #e8eaf6 0%, #c5cae9 50%, #e8eaf6 100%);
    background-size: 200% 100%;
    animation: ${pulse} 1.5s ease-in-out infinite;
  }

  .error-placeholder {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f5f5f5;
    color: #9e9e9e;

    i {
      font-size: 48px;
    }
  }

  .condition-badge {
    position: absolute;
    top: 8px;
    right: 8px;
    padding: 4px 8px;
    border-radius: 3px;
    font-size: 11px;
    font-weight: bold;
    color: #fff;
    text-transform: uppercase;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    z-index: 5;
  }

  .rent-badge {
    position: absolute;
    top: 8px;
    left: 8px;
    padding: 6px 12px;
    border-radius: 4px;
    font-size: 13px;
    font-weight: bold;
    color: #000;
    background-color: #FFD700;
    text-transform: uppercase;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
    z-index: 6;
    letter-spacing: 0.5px;
  }

  .price-badge {
    position: absolute;
    bottom: 12px;
    right: 12px;
    padding: 7px 13px;
    border-radius: 8px;
    font-size: 15px;
    font-weight: 700;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
    backdrop-filter: blur(4px);
    z-index: 10;
    color: #fff;

    &.negotiable {
      background: rgba(255, 152, 0, 0.95);
      font-size: 14px;
      font-weight: 600;
    }

    &.fixed {
      background: rgba(76, 175, 80, 0.95);
    }
  }
`;

export const AdImage = styled.div`
  height: 220px;
  width: 100%;
  background-image: url(${props => props.defaultImage});
  background-size: cover;
  background-position: center;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 60px;
    background: linear-gradient(to top, rgba(0,0,0,0.1), transparent);
    z-index: 1;
  };
`;